import config from "src/config";
import http, {
  postWithBasicHeader,
  getWithBasicHeader,
} from "../services/apiServices";

export const getInvoicesApi = async (filterData: any) => {
  return await postWithBasicHeader(config.Invoices.getInvoices, filterData);
};

export const payInvoicesApi = async (invoiceId: any) => {
  console.log("paying invoice : ", invoiceId);
  // return invoices; //await postWithBasicHeader(config.Invoices.viewInvoices, profileId);
};

export const generateInvoiceURLAPI = async (invoiceId: string) => {
  return await http.get(config.Invoices.generateInvoiceURL + invoiceId);
};

export const generateConsolidatedInvoiceURLAPI = async (invoiceId: string) => {
  return await http.get(config.Invoices.generateConsolidatedInvoiceURL, {
    params: { ConslidateInvoiceId: invoiceId },
  });
};

export const createConsolidatedInvoiceAPI = async (invoiceIds: any) => {
  return await http.post(config.Invoices.createConsolidatedInvoice, invoiceIds);
};

export const createInvoicesApi = async (invoiceId: any[]) => {
  let consolidatedInvoiceId = 123456;
  console.log("creating consolidatedInvoiceId : ", consolidatedInvoiceId);
  return consolidatedInvoiceId;
  // return invoices; //await postWithBasicHeader(config.Invoices.viewInvoices, profileId);
};
export const updateInvoicesApi = async (
  IsDelete: boolean,
  ConslidateInvoiceID: string,
  Invoices: any[]
) => {
  const data = {
    Invoices,
    ConslidateInvoiceID,
    IsDelete,
  };
  return await http.post(config.Invoices.updateConsolidatedInvoice, data);
};
export const getConsolidatedInvoicesApi = async (filterData: any) => {
  return await postWithBasicHeader(
    config.Invoices.getConsolidatedInvoices,
    filterData
  );
};

export const getInvoiceDetailsApi = async (invoiceId: string) => {
  return await http.get(config.Invoices.getInvoiceDetails, {
    params: { invoiceId },
  });
};
export const getConsolidatedInvoiceDetailsApi = async (invoiceId: string) => {
  return await http.get(config.Invoices.getConsolidatedInvoiceDetails, {
    params: { invoiceId },
  });
};

export const getUnpaidConsolidatedInvoiceHeaders = async () => {
  return await http.post(config.Invoices.getUnpaidConsolidatedInvoiceHeaders);
};
export const getPaymentClearanceApi = async () => {
  return await http.get(config.Invoices.getPaymentClearance);
};
